/**
 * Áreas + técnicos para "Alterar técnico" / Encaminhar no Board.
 * Hierarquia completa da equipe (área com coordenador e técnicos vinculados).
 * Não depende de coluna visível no board nem de técnico ter OS.
 *
 * @param {{ areas?: Array<{ id: *, nome?: string, coordenadorId?: * }>, tecnicos?: Array<{ id: *, nome?: string, areaId?: * }> }|null|undefined} teamData
 * @returns {Array<{ id: string, name: string, technicians: string[] }>}
 */
export function buildAreasWithTechniciansFromTeamData(teamData) {
  if (!teamData || !Array.isArray(teamData.areas) || !Array.isArray(teamData.tecnicos)) {
    return [];
  }

  const byName = (a, b) =>
    String(a).localeCompare(String(b), 'pt-BR', { sensitivity: 'base' });

  return teamData.areas
    .filter((area) => {
      if (!area || area.coordenadorId == null || area.coordenadorId === '') return false;
      return teamData.tecnicos.some((tec) => tec && tec.areaId === area.id);
    })
    .map((area) => {
      const technicians = teamData.tecnicos
        .filter((tec) => tec && tec.areaId === area.id)
        .map((tec) => tec.nome)
        .filter((nome) => nome != null && String(nome).trim())
        .map((nome) => String(nome).trim())
        .sort(byName);

      if (!technicians.length) return null;

      return {
        id: String(area.id),
        name: area.nome != null ? String(area.nome) : `Área ${area.id}`,
        technicians,
      };
    })
    .filter(Boolean)
    .sort((a, b) => byName(a.name, b.name));
}
